import { ForgeIcon, ForgePopover, ForgeTextField } from '@tylertech/forge-react';
import React from 'react';
import { I18n } from 'common/i18n';
import styles from './CustomSubtotalLabelField.module.scss';

const scope = 'shared.components.advanced_totaling.modal';

type CustomSubtotalLabelFieldProps = {
  onChange: (value: string) => void;
  initialValue: string;
};

const CustomSubtotalFieldPopover = () => (
  <label className={styles['custom-subtotal-info-popover-container']}>
    {I18n.t('subtotal_label', { scope })}
    <div className={styles['info-popover-container']}>
      <ForgeIcon
        name={'info_outline'}
        data-testid={'custom-subtotal-info-popover'}
        className={styles.icon}
        id={'custom-subtotal-info-popover'}
      ></ForgeIcon>
      <ForgePopover placement="right" trigger-type="hover" anchor={'custom-subtotal-info-popover'}>
        <div className={styles['info-popover-content']} data-testid="subtotal-label-info-popover-content">
          {I18n.t('subtotal_label_tooltip', { scope })}
        </div>
      </ForgePopover>
    </div>
  </label>
);

const CustomSubtotalLabelField = (props: CustomSubtotalLabelFieldProps) => {
  const { onChange, initialValue } = props;
  const handleSubtotalLabelFieldValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // TODO: Add Debounce
    onChange(event.target.value);
  };
  return (
    <ForgeTextField labelPosition={'block-start'}>
      <CustomSubtotalFieldPopover />
      <input
        data-testid="custom-subtotal-label-field"
        type="text"
        placeholder={I18n.t('enter_label', { scope })}
        onChange={handleSubtotalLabelFieldValueChange}
        value={initialValue}
      />
    </ForgeTextField>
  );
};

export default CustomSubtotalLabelField;
